// Swedish (sv-SE)
export default {
	title: "Betalningsmetoder",
	tips: "Kära användare, vänligen fyll i din ERC20/TRC20-adress. Vänligen ange inte dina bankkontouppgifter och lösenord",
	form: {
		TransactionPassword: "Transaktionslösenord",
		Address: "Plånboksadress"
	},
	label: ["Bankens Namn", "Avdelningskod", "Avdelningsnamn", "Insättnings Typ", "Kontonummer", "Kontoinnehavare"],
	tabs: ["Bankkort", "Nätverk"],
	delete: "Radera",
	default: "Standard",
	create: "Skapa",
	type: "Uttags Typ",
	verifying: "verifierar",
	VerifyWalletAddress: "Verifiera plånboksadress",
	defaultAccount: "Standard Uttagskonto",
	deleteMsg: "Är du säker på att du vill radera?"
};
